import isEmpty from "@/components/helpers/isEmpty"

export default function findSelectedUser(results, selectedUserId, selectedCustomerId) {
  // Pull out the selectedUser if needed
  if (isEmpty(results)) {
    return null
  }
  let selectedUser

  // there are better ways to do this - refactor
  results.pages.some((page) => {
    page.some((user) => {
      if (
        user.constituentId === Number.parseInt(selectedUserId, 10) &&
        user.customerId === selectedCustomerId
      ) {
        selectedUser = user
        return true
      }
      return false
    })
    if (selectedUser) {
      return true
    }
    return false
  })
  return selectedUser
}
